/* eslint-disable */
import { API_GET, API_POST, GET_MY, REQUEST_DATA, REQUEST_DATA_RESULT } from 'containers/App/constants';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { DELETE, GET, POST, PUT, PATCH } from 'utils/request';
import { EXECUTE_CONFIG_COMMANDS, LOGOUT } from '../../containers/App/constants';
import config from '../../env';
import {
  addApiError,
  addWork,
  //  API_callResult,
  API_keyInvalid,
  fetchMe,
  fetchMyTags,
  getConfig,
  reduceWork,
  removeApiError,
} from './actions';
import {
  API_ERROR,
  API_KEY_INVALID,
  REFRESH_TOKEN,
  REQUEST_API_KEY,
  REQUEST_API_KEY_REFRESH_RESULT,
  REQUEST_API_KEY_RESULT,
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_SET,
  RESET_API_KEY, SET_AZURE_API_KEY, SET_AZURE_API_KEY_RESULT,
} from './constants';
import { REQUEST_COMPANIES_SEARCH } from '../Companies/constants';
import { selectApiKey, selectApiRootUrl, selectConfig, selectMe, selectStoredRefreshToken } from './selectors';
import { UnprocessableEntityError } from '../../utils/errors/unprocessableEntityError';
import { fetchAddressTypes } from '../Address/actions';
import { fetchCountries, fetchHomeCompany } from '../Companies/actions';
import { ForbiddenError } from '../../utils/errors/forbiddenError';
import { ServerError } from '../../utils/errors/serverError';
import { REQUEST_USERS } from '../Users/constants';
import { getMsalContext } from "../Azure/helpers";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {REQUEST_UPDATE_INVOICE} from "../Invoices/constants";
import {INCOMING_CREDIT_LIMIT_NOT_ENOUGH} from "../../utils/request";

export function* generateApiUrl(path) {
  if (path[0] == '/') path = path.slice(1);
  path = path.replace(/\/\//g, '/');
  let root = yield select(selectApiRootUrl());
  return root + path;
}

export function* getUserId() {
  let apiKey = yield call(getApiKey);
  if (!apiKey || apiKey.user) return false;
  return apiKey.user.id;
}

export function* getApiKey() {
  if (config?.auth_flow === 'AZURE') {
    let apiKey = yield select(selectApiKey());
    const access_token_exp = apiKey?.access_token_exp;
    // Refresh token earlier then expiration date for 10000 miliseconds
    if (!access_token_exp || ((access_token_exp - 10000) < (new Date).getTime())) {
      yield call(refreshApiKeyAzure);
    }

    apiKey = yield select(selectApiKey());
    return  {
      access_token: apiKey?.access_token,
      id_token: apiKey?.access_token,
    };

  } else {
    let apiKey = yield select(selectApiKey());

    if (!apiKey || !apiKey.access_token) {
      return false;
    }

    if (new Date().getTime() > apiKey.access_token_exp) {
      let result = yield call(refreshApiKey);

      if (!result) {
        call(logout);
        return false;
      }

      apiKey = yield select(selectApiKey());
    }

    let time = new Date().getTime();
    let hourMS = 1000 * 60 * 60;
    let dayMS = hourMS * 24;

    //apikey MAX TTL = 2 days
    let maxTTL = dayMS * 2;

    if (time - new Date(apiKey.created_at).getTime() > maxTTL) {
      yield put({
        type: RESET_API_KEY,
      });
      return false;
    }

    return apiKey;
  }
}

export function* apiRequest(_path, data, method = 'POST', allowTokenRefresh = true, options = {}) {
  const path = _path;
  if (path.indexOf('public/') == 0) {
  } else {
    let apiKey = yield call(getApiKey);
    // if (!apiKey) yield call(logout);

    options.headers = {
      ...(options.headers ?? {}),
      Authorization: 'Bearer ' + apiKey.access_token,
    };
  }

  let url = yield call(generateApiUrl, path);
  let response;

  try {
    if (method == 'POST') {
      response = yield call(POST, url, data, options);
    } else if (method == 'DELETE') {
      response = yield call(DELETE, url, options, data);
    } else if (method == 'PUT') {
      response = yield call(PUT, url, data, options);
    } else if (method == 'PATCH') {
      response = yield call(PATCH, url, data, options);
    } else {
      response = yield call(GET, url, options);
    }
  } catch (error) {
    if (error == 'Unauthorized' && allowTokenRefresh) {
      // let tmp = yield call(refreshApiKey);
      //call self again, but with allowTokenRefresh = false
      return yield call(apiRequest, path, data, method, false);
    } else if (error == 'Unauthorized') {
      // debugger;
    }
    if (error instanceof UnprocessableEntityError) {
      if (error.validationErrors?.[0]?.children?.[0]?.property == 'size') {
        yield apiError('Bestand is te groot om te uploaden, maximaal toegestaan is 30MB per bestand');
      }
      return {
        result: false,
        validationErrors: error.validationErrors,
      };
    }
    if (error instanceof ForbiddenError) {
      return {
        result: false,
        forbiddenError: true,
        message: `Forbidden action: ${error.message}`,
      };
    }
    if (error instanceof ServerError) {
      return {
        result: false,
        message: error.message,
      };
    }

    const apiErrorMessage = error?.data?.message ?? API_ERROR;
    apiError(apiErrorMessage);

    return {
      result: false,
      supressError: true,
    };
  }

  return {
    result: response === false ? false : response.result === false ? false : true,
    data: response?.data?.data?.payload || response?.data || response?.message || null,
  };
}

let refresh_busy = false;

function* refreshApiKey() {
  if (refresh_busy) {
    yield new Promise(resolve => {
      let _interval = setInterval(() => {
        if (refresh_busy) return;
        else {
          clearInterval(_interval);
          resolve();
        }
      }, 200);
    });
  }

  let apiKey = yield select(selectApiKey());

  let refresh_token = apiKey?.refresh_token;
  let refresh_token_exp = apiKey?.refresh_token_exp;

  if (!refresh_token) {
    let r = yield select(selectStoredRefreshToken());
    refresh_token = r?.refresh_token;
    refresh_token_exp = r?.refresh_token_exp;
  }

  if (!refresh_token) {
    return false;
  }

  if (new Date().getTime() > refresh_token_exp) {
    console.log('refresh token expired, logout');
    yield call(logout);
    return false;
  }

  try {
    let url = yield call(generateApiUrl, `/auth/refresh-token`);

    refresh_busy = true;
    const response = yield call(
      POST,
      url,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + refresh_token,
        },
      },
    );
    refresh_busy = false;

    if (!response.data?.data?.payload?.access_token) {
      yield call(logout);
      return false;
    }

    yield put({
      type: REQUEST_API_KEY_REFRESH_RESULT,
      result: true,
      data: response.data?.data?.payload,
    });

    let me = yield select(selectMe());
    if (!me) yield put(fetchMe());

    return true;
  } catch (e) {
    console.error(e);
    yield call(logout);
    return false;
  }
}

function* refreshApiKeyAzure() {
  if (refresh_busy) {
    yield new Promise(resolve => {
      let _interval = setInterval(() => {
        if (refresh_busy) return;
        else {
          clearInterval(_interval);
          resolve();
        }
      }, 200);
    });
  }
  const msalContext = getMsalContext();
  const account = msalContext.getAllAccounts()?.[0];
  if (!account) {
    return false;
  }
  let data = {};
  try {
    data = yield call({fn: msalContext.acquireTokenSilent, context: msalContext}, {account});
  } catch(e) {
    if (e instanceof InteractionRequiredAuthError) yield call(logoutAzure);
    return;
  }
  if (!data?.idToken) {
    yield call(logoutAzure);
    return;
  }

  yield put({
    type: SET_AZURE_API_KEY,
    data,
  });
}


function* setAzureApiKey(data) {
  // remove any pending apikey error
  yield put(removeApiError(REQUEST_API_KEY));

  yield gate(REQUEST_API_KEY, function*() {
    yield work(REQUEST_API_KEY, function*() {
      try {
        if (!data?.data?.idToken) {
          return yield apiError(REQUEST_API_KEY, 'AZURE_ERROR');
        }
        yield put({
          type: SET_AZURE_API_KEY_RESULT,
          result: true,
          data: data.data,
        });
        yield put(getConfig());
        yield put(fetchMe());
        yield put(fetchAddressTypes());
        yield put(fetchCountries());
        yield put(fetchHomeCompany());
      } catch (e) {
        console.error(e);
      }
    });
  });
}

function* requestApiKey({ email, password, refresh_token, rememberMe, callback }) {
  // remove any pending apikey error
  yield put(removeApiError(REQUEST_API_KEY));

  yield gate(REQUEST_API_KEY, function*() {
    yield work(REQUEST_API_KEY, function*() {
      let url = yield call(generateApiUrl, `auth/login`);

      try {
        const response = yield call(POST, url, {
          email,
          password,
        });
        const data = response.data?.data?.payload;

        if (!data?.access_token) {
          return yield apiError(REQUEST_API_KEY, response);
        }

        yield put({
          type: REQUEST_API_KEY_RESULT,
          result: true,
          data,
          rememberMe,
        });
        yield put(getConfig());
        //yield put(fetchMyTags());

        if (callback)
          callback({
            result: true,
            data: response.data,
          });

        yield put(fetchMe());
        yield put(fetchAddressTypes());
        yield put(fetchCountries());
        yield put(fetchHomeCompany());
      } catch (e) {
        console.error(e);
      }
    });
  });
}

function* requestPasswordReset({ email, callback }) {
  let result = yield work(REQUEST_PASSWORD_RESET, function*() {
    return yield call(apiRequest, 'public/reset-password', { email }, 'POST');
  });
  if (callback) callback(result);
}

function* requestPasswordSet({ password, code, callback }) {
  let result = yield work(REQUEST_PASSWORD_SET, function*() {
    return yield call(apiRequest, `public/set-password`, { password, code }, 'POST');
  });
  if (callback) callback(result);
}

function* requestData({ id, request, filter }) {
  let result;

  if (request.method == 'GET') {
    result = yield call(apiRequest, request.path, null, 'GET');
  } else {
    result = yield call(apiRequest, `${request.select.type}/${request.select.name}`, { filter });
  }

  if (result.data !== undefined) result = result.data.data.payload;

  yield put({ type: REQUEST_DATA_RESULT, result, request, id, filter });
}

export function* api_POST({ request }) {
  return yield call(apiRequest, request.path, request.data, 'POST');
}

export function* api_GET({ request }) {
  return yield call(apiRequest, request.path, null, 'GET');
}

export function* api_DELETE({ request }) {
  return yield call(apiRequest, request.path, null, 'DELETE');
}

export function* api_PUT({ request }) {
  return yield call(apiRequest, request.path, request.data, 'PUT');
}

export function* api_PATCH({ request }) {
  return yield call(apiRequest, request.path, request.data, 'PATCH');
}

export function* post(action) {
  if (!action.authorized) {
    return yield work(action.work, function*() {
      let url = yield generateApiUrl(action.path);
      let response = yield call(POST, url, action.post, action.options);
      action.callback(response);
    });
  } else throw 'not yet implemented';
}

export function* getMy(action) {
  let path = action.path;
  let result;

  return yield gate(action.gate, function*() {
    return yield work(action.work || 'api_getMy', function*() {
      if (action.post) {
        result = yield call(apiRequest, path, action.post, 'POST', true, action.options);
      } else if (action.delete) {
        result = yield call(apiRequest, path, action.delete, 'DELETE');
      } else if (action.put) {
        result = yield call(apiRequest, path, action.put, 'PUT');
      } else if (action.patch) {
        result = yield call(apiRequest, path, action.patch, 'PATCH');
      } else {
        result = yield call(apiRequest, path, null, 'GET');
      }
      if (result.forbiddenError) {
        if (action.callback) action.callback(result);
        yield apiError(result.message);
        return;
      }

      if (result && result.result) result = result.data !== undefined ? result.data : result;
      else {
        if (result.supressError) {
          return;
        }

        //show a general api error if there is no callback specified
        if (action.callback) action.callback(result);
        else {
          console.warn('my/api error');
          yield apiError(result.message ?? 'General');
        }
        return;
      }

      delete action.type;
      yield put({ type: REQUEST_DATA_RESULT, result, ...action });

      if (action.callback) {
        action.callback(result);
      }

      if (result.message === INCOMING_CREDIT_LIMIT_NOT_ENOUGH) {
        delete action.putOnComplete;
      }


      if (action.putOnComplete) {
        if (_.isArray(action.putOnComplete)) {
          for (let i in action.putOnComplete) {
            yield put(action.putOnComplete[i]);
          }
        } else {
          yield put(action.putOnComplete);
        }
      }

      // if (!result) debugger;

      return result;
    });
  });
}

let gates = {};

//make a function not run more than once
export function* gate(id, fn) {
  //if we put this in the a reducer through an action
  // multiple of the same events might still happen because
  // the reducer is is not updated instantly

  if (id && id in gates) {
    let result = yield new Promise(resolve => gates[id].push(resolve));
    if (id == 'app/modules/Contents/REQUEST_KANBAN_BOARD_COLUMN_CELLS52_457') debugger;
    console.log('gate result', result);
    return result;
  }

  gates[id] = [];

  let result = yield fn();

  for (let i in gates[id]) gates[id][i](result);

  delete gates[id];

  return result;
}

//keep track of running work (like a on-going post request)
export function* work(id, fn, data = null) {
  yield put(addWork(id, data));
  let result;
  try {
    result = yield fn();
  } catch (e) {
    yield apiError();
    console.dir(e);
    console.error(e);
    console.error('WORK error : ' + id);
  }
  yield put(reduceWork(id, data));

  return result;
}

export function* apiError(id = 'general', data = null) {
  yield put(addApiError(id, data));
}

export function* logout() {
  yield put({
    type: RESET_API_KEY,
    logout: true,
  });
}

export function* logoutAzure() {
  const msalContext = getMsalContext();
  const account = msalContext.getAllAccounts()?.[0];
  const logoutRequest = {
    account,
    postLogoutRedirectUri: config.azure_logout_redirect_uri,
  };

  yield call({ fn: msalContext.logoutRedirect, context: msalContext }, logoutRequest);
}

function* executeConfigCommands() {
  let config = yield select(selectConfig());

  if (!config.commands) return;

  for (let i = 0; i < config.commands.length; i++) {
    let command = config.commands[i];
    switch (
      command.name
      // case 'insta':
      //     let result = yield call(GET, 'https://www.instagram.com/dutchvansautos/?__a=1');
      //     console.dir(result);
      //     if(result && result.graphql){
      //         yield call(apiRequest,'/command/insta', {feed:result});
      //     }
      //     break;
    ) {
    }
  }
}

export default function* apis() {
  const EXCEPTION_ACTIONS = [REQUEST_COMPANIES_SEARCH, REQUEST_USERS];
  yield all([
    takeEvery(REQUEST_API_KEY, requestApiKey),
    takeEvery(REQUEST_PASSWORD_RESET, requestPasswordReset),
    takeEvery(REQUEST_PASSWORD_SET, requestPasswordSet),
    takeEvery(REQUEST_DATA, requestData),
    takeEvery(REFRESH_TOKEN, config?.auth_flow === 'AZURE' ? refreshApiKeyAzure : refreshApiKey),
    takeEvery(API_POST, post),
    takeEvery(API_GET, api_GET),
    takeEvery(action => action.type === GET_MY && !EXCEPTION_ACTIONS?.includes(action.work), getMy),
    takeLatest(action => action.type === GET_MY && !!EXCEPTION_ACTIONS?.includes(action.work), getMy),
    takeEvery(LOGOUT, config?.auth_flow === 'AZURE' ? logoutAzure : logout),
    takeEvery(API_KEY_INVALID, logout),
    takeEvery(EXECUTE_CONFIG_COMMANDS, executeConfigCommands),
    takeEvery(SET_AZURE_API_KEY, setAzureApiKey),
  ]);
}
